import type { CellContext } from '@/components/ui/table/types'
import { type Project, ProjectStatusBadge } from '@/modules/projects'

export const StatusCell = (cell: CellContext<Project, string>) => (
  <ProjectStatusBadge status={cell.getValue()} />
)
